// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rightSideContainer {
  width: 100%;
}
.submitBtn {
  background-color: var(--theme1);
  color: var(--white);
  border: 0;
  padding: 6px;
  /* height: 45px; */
  border-radius: 6px;
  /* font-weight: 500; */
  width: 100%;
}

.submitBtn:hover {
  background-color: var(--theme2);
}

.submitBtn:disabled {
  background-color: #1f1f1f8c;
  color: var(--white) !important;
}

.panel-content .pageTitle {
  box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
}

.panel-content .pageTitle .Title {
  font-weight: bold;
}

/* .btn.cancelBtn{
    border-radius: 8px;
    border: solid 1px var(--theme2);
} */

.btn.cancelBtn,
.btn.addMoreBtn {
  background-color: #24449452;
  color: var(--theme1);
  font-weight: 700;
}

.btn.cancelBtn:hover {
  background-color: var(--theme1);
  color: var(--white);
}

.btn.addMoreBtn:hover {
  background-color: var(--theme1);
  color: var(--white);
}

.cursor {
  cursor: pointer;
}

.required {
  color: red;
}

.modelChat {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001 !important;
}

.btn:hover {
  background-color: var(--theme1) !important;
  color: var(--white) !important;
}

.btn.outline {
  border: 1px solid #e0dfdf;
}

.btn :focus-visible {
  background-color: var(--theme1) !important;
  ;
  color: var(--white) !important;
  font-weight: 500 !important;
}

.btn.active {
  background-color: var(--theme1) !important;
  color: var(--white) !important;
  font-weight: 500 !important;
}

.btn:disabled {
  background-color: var(--grey) !important;
  color: var(--white) !important;
}

.editMode {
  padding: 1.5rem 1rem;
  width: 75%;
}

@media (max-width:"991px") {
  .editMode {
    width: 100%;
  }
}

.loaderBackdrop {
  background: rgba(0, 0, 0, 0.68) !important;
  backdrop-filter: blur(3px);
  z-index: 9999 !important;
}

.loader {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 28px 32px;
}

.loader span {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  opacity: 1;
  animation: loaderWave 1.1s infinite ease-in-out;
  border: 1px solid rgba(0, 0, 0, 0.25);
}

/* Dark blue */
.loader span:nth-child(1),
.loader span:nth-child(3) {
  background-color: #0d47a1;
  box-shadow: 0 3px 10px rgba(13, 71, 161, 0.65);
}

/* Dark orange */
.loader span:nth-child(2),
.loader span:nth-child(4) {
  background-color: #c2410c;
  box-shadow: 0 3px 10px rgba(194, 65, 12, 0.65);
}

@keyframes loaderWave {

  0%,
  100% {
    transform: translateY(7px) scale(0.9);
    opacity: 0.85;
  }

  50% {
    transform: translateY(-14px) scale(1.35);
    opacity: 1;
  }
}

.loader span:nth-child(1) {
  animation-delay: 0s;
}

.loader span:nth-child(2) {
  animation-delay: 0.12s;
}

.loader span:nth-child(3) {
  animation-delay: 0.24s;
}

.loader span:nth-child(4) {
  animation-delay: 0.36s;
}

@keyframes loaderWave {

  0%,
  100% {
    transform: translateY(7px) scale(0.85);
    opacity: 0.75;
  }

  50% {
    transform: translateY(-14px) scale(1.35);
    opacity: 1;
    filter: brightness(1.25);
  }
}

@media (prefers-reduced-motion: reduce) {
  .loader span {
    animation: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;GAGG;;AAEH;;EAEE,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;;EAE1C,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA,cAAc;AACd;;EAEE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA,gBAAgB;AAChB;;EAEE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;;EAEE;;IAEE,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,wCAAwC;IACxC,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE;;IAEE,sCAAsC;IACtC,aAAa;EACf;;EAEA;IACE,wCAAwC;IACxC,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".rightSideContainer {\n  width: 100%;\n}\n.submitBtn {\n  background-color: var(--theme1);\n  color: var(--white);\n  border: 0;\n  padding: 6px;\n  /* height: 45px; */\n  border-radius: 6px;\n  /* font-weight: 500; */\n  width: 100%;\n}\n\n.submitBtn:hover {\n  background-color: var(--theme2);\n}\n\n.submitBtn:disabled {\n  background-color: #1f1f1f8c;\n  color: var(--white) !important;\n}\n\n.panel-content .pageTitle {\n  box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;\n}\n\n.panel-content .pageTitle .Title {\n  font-weight: bold;\n}\n\n/* .btn.cancelBtn{\n    border-radius: 8px;\n    border: solid 1px var(--theme2);\n} */\n\n.btn.cancelBtn,\n.btn.addMoreBtn {\n  background-color: #24449452;\n  color: var(--theme1);\n  font-weight: 700;\n}\n\n.btn.cancelBtn:hover {\n  background-color: var(--theme1);\n  color: var(--white);\n}\n\n.btn.addMoreBtn:hover {\n  background-color: var(--theme1);\n  color: var(--white);\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.required {\n  color: red;\n}\n\n.modelChat {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10001 !important;\n}\n\n.btn:hover {\n  background-color: var(--theme1) !important;\n  color: var(--white) !important;\n}\n\n.btn.outline {\n  border: 1px solid #e0dfdf;\n}\n\n.btn :focus-visible {\n  background-color: var(--theme1) !important;\n  ;\n  color: var(--white) !important;\n  font-weight: 500 !important;\n}\n\n.btn.active {\n  background-color: var(--theme1) !important;\n  color: var(--white) !important;\n  font-weight: 500 !important;\n}\n\n.btn:disabled {\n  background-color: var(--grey) !important;\n  color: var(--white) !important;\n}\n\n.editMode {\n  padding: 1.5rem 1rem;\n  width: 75%;\n}\n\n@media (max-width:\"991px\") {\n  .editMode {\n    width: 100%;\n  }\n}\n\n.loaderBackdrop {\n  background: rgba(0, 0, 0, 0.68) !important;\n  backdrop-filter: blur(3px);\n  z-index: 9999 !important;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 28px 32px;\n}\n\n.loader span {\n  width: 17px;\n  height: 17px;\n  border-radius: 50%;\n  opacity: 1;\n  animation: loaderWave 1.1s infinite ease-in-out;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n}\n\n/* Dark blue */\n.loader span:nth-child(1),\n.loader span:nth-child(3) {\n  background-color: #0d47a1;\n  box-shadow: 0 3px 10px rgba(13, 71, 161, 0.65);\n}\n\n/* Dark orange */\n.loader span:nth-child(2),\n.loader span:nth-child(4) {\n  background-color: #c2410c;\n  box-shadow: 0 3px 10px rgba(194, 65, 12, 0.65);\n}\n\n@keyframes loaderWave {\n\n  0%,\n  100% {\n    transform: translateY(7px) scale(0.9);\n    opacity: 0.85;\n  }\n\n  50% {\n    transform: translateY(-14px) scale(1.35);\n    opacity: 1;\n  }\n}\n\n.loader span:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.loader span:nth-child(2) {\n  animation-delay: 0.12s;\n}\n\n.loader span:nth-child(3) {\n  animation-delay: 0.24s;\n}\n\n.loader span:nth-child(4) {\n  animation-delay: 0.36s;\n}\n\n@keyframes loaderWave {\n\n  0%,\n  100% {\n    transform: translateY(7px) scale(0.85);\n    opacity: 0.75;\n  }\n\n  50% {\n    transform: translateY(-14px) scale(1.35);\n    opacity: 1;\n    filter: brightness(1.25);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .loader span {\n    animation: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
